import { store } from "../store";
import { API_CONFIG } from "./constants/constant";
import http from "./http.service";

const getBillPaymentList = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "BILLPAYMENT",

      userGroupId: parseInt(profileDetails["profileId"] || 0),
      page: 0,
      status: "SUCCESS",
      size: 1000,
      ...data,
      mobileNo: profileDetails["plainMobileNo"] || "",
    };
    const response = await http.post(API_CONFIG.getBillPaymentList, reqParams);
    return {
      status: response.status,
      data: response.data["data"] || [],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getBillerCategories = async (data) => {
  try {
    const reqParams = {
      requestId: "GET_BILLER_CATEGORIES",
      module: "BILLPAYMENT",
      ...data,
    };
    const response = await http.post(API_CONFIG.getBillerCategories, reqParams);
    return {
      status: response.status,
      data: response.data["data"] || [],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getBillersByCategory = async (data) => {
  try {
    const reqParams = {
      requestId: "GET_BILLERS_BY_CATEGORY",
      module: "BILLPAYMENT",
      ...data,
      page: 0,
      size: 1000,
    };
    const response = await http.post(
      API_CONFIG.getBillersByCategory,
      reqParams
    );
    return {
      status: response.status,
      data: response.data["data"] || [],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const viewBillerList = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "GET_BILLER_BENE",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      page: 0,
      size: 1000,
      ...data,
      mobileNo: profileDetails["plainMobileNo"] || "",
    };
    const response = await http.post(API_CONFIG.viewBillerList, reqParams);
    return {
      status: response.status,
      data: response.data["data"] || [],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const deleteBillerVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "BILLERBENE_DELETE_VERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
      mobileNo: profileDetails["plainMobileNo"] || "",
    };
    const response = await http.post(API_CONFIG.deleteBillerVerify, reqParams);
    return {
      status: response.status,
      data: response.data["data"] || [],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const deleteBillerConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "BILLERBENE_DELETE_CONFIRM",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
      mobileNo: profileDetails["plainMobileNo"] || "",
    };
    const response = await http.post(API_CONFIG.deleteBillerConfirm, reqParams);
    return {
      status: response.status,
      data: response.data || [],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};
const getCustomParamsByBillerId = async (data) => {
  try {
    const reqParams = {
      requestId: "GET_CUSTOM_PARAMS_BY_BILLER_ID",
      module: "BILLPAYMENT",
      ...data,
    };
    const response = await http.post(
      API_CONFIG.getCustomParamsByBillerId,
      reqParams
    );
    return {
      status: response.status,
      data: response.data["data"] || [],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};
const billPaymentVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "BILLPAYMENT_VERIFY",
      module: "BILLPAYMENT",
      ...data,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mobileNo: profileDetails["plainMobileNo"] || "",
    };
    const response = await http.post(API_CONFIG.billPaymentVerify, reqParams);
    return {
      status: response.status,
      data: response.data["data"] || [],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const billPaymentConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "BILLPAYMENT_CONFIRM",
      module: "BILLPAYMENT",
      ...data,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mobileNo: profileDetails["plainMobileNo"] || "",
    };
    const response = await http.post(API_CONFIG.billPaymentConfirm, reqParams);
    return {
      status: response.status,
      data: response.data["data"] || [],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};
const addBillerVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "ADD_BILLER_BENE_VERIFY",
      module: "BILLPAYMENT",
      ...data,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mobileNo: profileDetails["plainMobileNo"] || "",
    };
    const response = await http.post(API_CONFIG.addBillerVerify, reqParams);
    return {
      status: response.status,
      data: response.data["data"] || [],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const addBillerConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "ADD_BILLER_BENE_VERIFY",
      module: "BILLPAYMENT",
      ...data,
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mobileNo: profileDetails["plainMobileNo"] || "",
    };
    const response = await http.post(API_CONFIG.addBillerConfirm, reqParams);
    return {
      status: response.status,
      data: response.data["data"] || [],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getBillerBeneficiary = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "GET_BILLER_BENE",
      module: "BILLPAYMENT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
      page: 0,
      size: 1000,
      mobileNo: profileDetails["plainMobileNo"] || "",
    };
    const response = await http.post(
      API_CONFIG.getBillerBeneficiary,
      reqParams
    );
    return {
      status: response.status,
      data: response.data["data"] || [],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getbillQuote = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "BILLQUOTE",
      module: "BILLPAYMENT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
      mobileNo: profileDetails["plainMobileNo"] || "",
    };
    const response = await http.post(API_CONFIG.getbillQuote, reqParams);
    return {
      status: response.status,
      data: response.data["data"] || [],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const paymentHistory = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      module: "BILLPAYMENT",
      requestId: "BILLPAYMENT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mobileNo: profileDetails["plainMobileNo"] || "",
    };
    const response = await http.post(API_CONFIG.paymentHistory, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const gepg_billEnquiry = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      module: "GEPG",
      requestId: "BILLENQUIRY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mobileNo: profileDetails["plainMobileNo"] || "",
    };
    const response = await http.post(API_CONFIG.gepg_billEnquiry, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const gepg_initVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      module: "BILLPAYMENT",
      requestId: "BILLPOSTVERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mobileNo: profileDetails["plainMobileNo"] || "",
    };
    const response = await http.post(API_CONFIG.gepg_initVerify, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const gepg_initConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      module: "BILLPAYMENT",
      requestId: "BILLPOSTCONFIRM",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mobileNo: profileDetails["plainMobileNo"] || "",
    };
    const response = await http.post(API_CONFIG.gepg_initConfirm, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const viewScheduledPayments = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;

    const reqParams = {
      ...data,
      requestId: "VIEW_SCHEDULED_PAYMENTS",
      module: "BILLPAYMENT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mobileNo: profileDetails["plainMobileNo"] || "",
    };
    const response = await http.post(
      API_CONFIG.viewScheduledPayments,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const modifyOrCancelScheduledPaymentVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "BILLPAYMENT_VERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
      mobileNo: profileDetails["plainMobileNo"] || "",
    };
    const response = await http.post(
      API_CONFIG.modifyOrCancelScheduledPaymentsVerify,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const modifyOrCancelScheduledPaymentConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "BILLPAYMENT_VERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
      mobileNo: profileDetails["plainMobileNo"] || "",
    };
    const response = await http.post(
      API_CONFIG.modifyOrCancelScheduledPaymentsConfirm,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const gepg_History = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      module: "GEPG",
      requestId: "GEPGRECORDS",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mobileNo: profileDetails["plainMobileNo"] || "",
    };
    const response = await http.post(API_CONFIG.gepg_History, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};
const modifyBillerVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "BILLERBENE_DELETE_VERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
      mobileNo: profileDetails["plainMobileNo"] || "",
    };
    const response = await http.post(API_CONFIG.modifyBillerVerify, reqParams);
    return {
      status: response.status,
      data: response.data["data"] || [],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const modifyBillerConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "BILLPAYMENT",
      requestId: "DELETE_BILLER_BENE_CONFIRM",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
      mobileNo: profileDetails["plainMobileNo"] || "",
    };
    const response = await http.post(API_CONFIG.modifyBillerConfirm, reqParams);
    return {
      status: response.status,
      data: response.data || [],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getPendingBills = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "BILLQUOTE",
      module: "BILLPAYMENT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
      mobileNo: profileDetails["plainMobileNo"] || "",
    };
    const response = await http.post(API_CONFIG.getPendingBills, reqParams);
    return {
      status: response.status,
      data: response.data["data"] || [],
    };
  } catch (err) {
    return Promise.reject(err);
  }
};

const PaymentService = {
  getBillPaymentList,
  getBillerCategories,
  getBillersByCategory,
  viewBillerList,
  deleteBillerVerify,
  deleteBillerConfirm,
  getCustomParamsByBillerId,
  billPaymentVerify,
  addBillerVerify,
  billPaymentConfirm,
  getBillerBeneficiary,
  getbillQuote,
  addBillerConfirm,
  paymentHistory,
  gepg_billEnquiry,
  gepg_initVerify,
  gepg_initConfirm,
  viewScheduledPayments,
  modifyOrCancelScheduledPaymentVerify,
  modifyOrCancelScheduledPaymentConfirm,
  gepg_History,
  modifyBillerVerify,
  modifyBillerConfirm,
  getPendingBills,
};

export default PaymentService;
